import { useState, useEffect } from "react";

const heroTitles = [
  {
    main: "Independent Search Specialists",
    highlight: ["for Smarter Conveyancing"]
  },
  {
    main: "Comprehensive",
    highlight: ["Conveyancing Searches", "in One Place"]
  },
  {
    main: "Everything You Need for",
    highlight: ["Property Searches", ""]
  },
  {
    main: "One-Stop Shop for",
    highlight: ["All Property Searches", ""]
  },
  {
    main: "Professional",
    highlight: ["Property Searches", "Made Simple"]
  }
];

export default function HeroTitleRotator() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      
      setTimeout(() => {
        setActiveIndex((prev) => (prev + 1) % heroTitles.length);
        setIsVisible(true);
      }, 300);
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const currentTitle = heroTitles[activeIndex];

  return (
    <h1 className={`text-4xl md:text-6xl font-bold text-white mb-6 transition-opacity duration-300 ${
      isVisible ? 'opacity-100' : 'opacity-0'
    }`}>
      {currentTitle.main}<br />
      <span className="text-green-400">{currentTitle.highlight[0]}</span>
      {currentTitle.highlight[1] && (
        <>
          <br />
          <span className="text-green-400">{currentTitle.highlight[1]}</span>
        </>
      )}
    </h1>
  );
} 